import { Chip } from "@mui/material";
import constants from "../utils/constants";

function ArrowDownChip({ onClick }) {
	return (
		<>
			<Chip
				label={
					<ion-icon
						name="chevron-down-outline"
						style={{
							color: constants.PRIMARY,
							marginTop: "6px",
						}}
					></ion-icon>
				}
				style={{
					fontSize: 25,
					float: "right",
					marginTop: 10,
				}}
				onClick={() => {
					onClick();
				}}
				color="primary"
				variant="outlined"
			/>
		</>
	);
}

export default ArrowDownChip;
